import { render, staticRenderFns } from "./BurnList.vue?vue&type=template&id=b749c602&scoped=true&"
import script from "./BurnList.vue?vue&type=script&lang=js&"
export * from "./BurnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b749c602",
  null
  
)

export default component.exports